export default "__VITE_ASSET__DyKP8_sa__"